module.exports = __webpack_public_path__ + "static/media/12.877c11a4.JPG";